import { useCallback, useState } from 'react';
import API from '@scale/frontend-lib/dashboard-api';
import {
  IndexedInteractionStepResponse,
  MultiTurnInteractionConfiguration,
  SavedCorpDialogue,
} from '@scale/shared/types/chat';
import { Button, Typography, Modal, TextField } from '@scale/scaleui';

export function SaveDialogueModal({
  open,
  onClose,
  config,
  responses,
  dialogue,
}: {
  open: boolean;
  onClose: () => void;
  config: MultiTurnInteractionConfiguration;
  responses: IndexedInteractionStepResponse[];
  dialogue?: SavedCorpDialogue;
}) {
  const [title, setTitle] = useState<string>(dialogue?.title || '');
  const [description, setDescription] = useState<string>(dialogue?.description || '');
  const [isSaving, setIsSaving] = useState<boolean>(false);

  const saveDialogue = useCallback(async () => {
    setIsSaving(true);
    if (dialogue) {
      await API.genai.updateCorpDialogue({
        dialogueId: dialogue._id,
        title,
        description,
      });
    } else {
      await API.genai.saveCorpDialogue({
        title,
        description,
        config,
        responses,
        tags: [],
        context: {},
      });
    }
    setIsSaving(false);
    onClose();
  }, [dialogue, title, description, config, responses, onClose, setIsSaving]);

  return (
    <Modal onClose={onClose} open={open}>
      <div className="flex flex-col gap-2">
        <Typography.Subtitle2>Save Dialogue</Typography.Subtitle2>
        <TextField
          id="title"
          label="Title"
          placeholder="Name for your configuration"
          value={title}
          onChange={e => setTitle(e.target.value)}
        />
        <TextField
          id="description"
          label="Description (optional)"
          placeholder="Write a brief description for this configuration"
          value={description}
          onChange={e => setDescription(e.target.value)}
        />
        <div className="flex justify-end items-center gap-1">
          <Button variant="danger" onClick={onClose}>
            Cancel
          </Button>
          <Button disabled={title === '' || isSaving} onClick={saveDialogue}>
            Save
          </Button>
        </div>
      </div>
    </Modal>
  );
}
